import { Injectable, Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
  name: "dateFormat",
  standalone: true,
})
@Injectable()
export class DateFormatPipe implements PipeTransform {
  public transform(date: any, ddMMYYY: string): any {
    if (date) {
      return moment(date).format(ddMMYYY);
    }
  }
}
